import { getSentryConfig } from '@beef/shop-common';
import { init, browserTracingIntegration } from '@sentry/react';

const { enabled, ...config } = getSentryConfig();

if (enabled) {
  init({
    ...config,
    integrations: [browserTracingIntegration()],
    tracesSampleRate: 0.1,
    sampleRate: 1.0,
  });
}
